
import { Component, Prop, Vue } from "vue-property-decorator";
import BodyElementConfigComponent from "./body-element-config.vue";

import StreamComponent from "./stream.vue";
import LiveEventsComponent from "./liveevents.vue";
import TelemetryComponent from "./telemetry.vue";
import SpacecraftMapComponent from "./spacecraftmap.vue";
import ISSMCCMapComponent from "./issmccmap.vue";
import { MoveTileDirInterface, MoveTileInterface, TileIndex } from "../../store/config.types";

@Component({
  components: {
    "body-element-config": BodyElementConfigComponent,
    "stream-component": StreamComponent,
    "liveevents-component": LiveEventsComponent,
    "telemetry-component": TelemetryComponent,
    "spacecraftmap-component": SpacecraftMapComponent,
    "issmccmap-component": ISSMCCMapComponent
  },
})
export default class BodyElementComponent extends Vue {
  @Prop() tileIndex!: TileIndex;
  tileEdit: boolean = false;

  get tileConfig() {
    return this.$store.getters["config/getTileConfig"](this.tileIndex);
  }

  get editModeState() {
    return this.$store.getters["editModeState"];
  }

  moveTile(dir: MoveTileDirInterface) {
    this.$store.dispatch("config/moveTile", {index: this.tileIndex, dir} as MoveTileInterface)
  }
}
